import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2866cdcb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2866cdcb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2866cdcb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2866cdcb')) {
      api.createRecord('2866cdcb', component.options)
    } else {
      api.reload('2866cdcb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2866cdcb&scoped=true", function () {
      api.rerender('2866cdcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/workDealt/components/index.vue"
export default component.exports